import React from 'react';
import { getClientRender, ApplyPluginsType, dynamic, getDynamicModule, importMF, importMFComponent, utils } from '@sui/sui';
import { NotFoundComponentModule, fallbackDom } from '@@/core/runtime';
import plugin from '@@/core/plugin';
import models, { dispatcher } from './model';
import * as Plugin_model from './plugin-model';
import * as Plugin_access from './plugin-access';
import * as app from '@/app';
const { microApp } = app || {};
const fallback = fallbackDom

const { pick, uuid } = utils;

// 注册插件
plugin.register({
  apply: pick(app, plugin.supportHooks),
  path: './src/app'
})
plugin.register({
  apply: Plugin_access,
  path: './.sui/plugin-access'
})

plugin.register({
  apply: Plugin_model,
  path: './.sui/plugin-model'
})

// 导入并注册remote应用
const remotes = {

}

//创建路由
const routes = [
	{
		"path": "/",
		"component": require('@/pages/index.js').default
	},
	{
		"path": "/single",
		"component": require('@/pages/index.js').default
	},
	{
		"path": "/newChat",
		"component": require('@/routes/nblg/agent/index.jsx').default
	},
	{
		"path": "/newSearch",
		"component": require('@/routes/nblg/portal/index.jsx').default
	},
	{
		"path": "/zdHome",
		"component": require('@/routes/zd/home/index.js').default
	},
	{
		"path": "/zdChat",
		"component": require('@/pages/index.js').default
	},
	{
		"path": "/manage",
		"component": require('@/pages/manage/index.js').default
	}
] || [];

// on start
plugin.applyPlugins({
  key:"onStart",
  type: ApplyPluginsType.action,
  args: {
    plugin
  }
})

// routes filter
plugin.applyPlugins({
    key: "modifyRoutes",
    type: ApplyPluginsType.action,
    args: {
        routes
    }
})



const suiOpts = {
      version: "3.1.128",
      runtimeVersion:"3.1.70",
      pluginsVers: {},
      routes,
      plugin,
      models,
      remotes,
      dispatcher,
      __client_render_id__: uuid()
}

// 运行时渲染配置项，可级调用覆盖
const renderOpts = {
      mountContainer: "root",
      defaultTitle: "loading",
      history: {"type":"hash","basename":"/"},
      loading: fallback,
}

if(window.historyBasename) {
    renderOpts.history = Object.assign({ type:'hash', basename: '/' }, renderOpts.history, { basename:  window.historyBasename })
}
if( renderOpts.history && renderOpts.history.type === 'browser' && window.historyPrefixPath ){
    renderOpts.history.basename =  utils.joinPaths([window.historyPrefixPath, renderOpts.history.basename || '/' ])
}

export default function render(opts){
    const options = Object.assign({}, renderOpts, opts || {}, suiOpts)
    const clientRender = getClientRender(options)
    return clientRender()
}

export { microApp };

// generated at 2026/7/8 18:49:32 by sui v3.1.128